module.exports = __webpack_public_path__ + "img/thumbnail.807578a0.jpg";